// Config Tab Component
export default function ConfigTab({
  siteConfig,
  editingConfig,
  setEditingConfig,
  tempUpdateDate,
  setTempUpdateDate,
  onUpdate,
  onSetToday
}: {
  siteConfig: { _id?: string; configKey: string; configValue: string; description: string } | null
  editingConfig: boolean
  setEditingConfig: (editing: boolean) => void
  tempUpdateDate: string
  setTempUpdateDate: (date: string) => void
  onUpdate: () => Promise<void>
  onSetToday: () => Promise<void>
}) {
  return (
    <div className="max-w-2xl">
      <div className="border-4 border-black p-8">
        <h2 className="text-2xl font-black mb-6">站点配置管理</h2>
        
        <div className="space-y-6">
          {/* Current Update Date Display */}
          <div className="bg-gray-50 p-6 border-2 border-black">
            <div className="flex justify-between items-center mb-4">
              <h3 className="text-xl font-bold">最后更新日期</h3>
              {!editingConfig && (
                <button
                  onClick={() => {
                    setEditingConfig(true)
                    setTempUpdateDate(siteConfig?.configValue || '')
                  }}
                  className="bg-black text-white px-4 py-2 font-bold hover:bg-gray-800 transition-colors"
                >
                  修改
                </button>
              )}
            </div>
            
            <div className="text-3xl font-black mb-2">
              {siteConfig?.configValue || '未设置'}
            </div>
            
            <div className="text-sm text-gray-600">
              {siteConfig?.description || '暂无描述'}
            </div>
          </div>
          
          {/* Edit Form */}
          {editingConfig && (
            <div className="bg-white p-6 border-4 border-black">
              <h3 className="text-xl font-bold mb-4">编辑更新日期</h3>
              
              <div className="space-y-4">
                <div>
                  <label className="block text-lg font-bold mb-2">
                    新日期（格式: YYYY.MM.DD）
                  </label>
                  <input
                    type="text"
                    value={tempUpdateDate}
                    onChange={(e) => setTempUpdateDate(e.target.value)}
                    placeholder="例如: 2025.8.1"
                    className="w-full p-3 border-2 border-black text-lg font-mono"
                  />
                </div>
                
                <div className="flex space-x-4">
                  <button
                    onClick={onSetToday}
                    className="bg-blue-600 text-white px-6 py-3 font-bold hover:bg-blue-700 transition-colors"
                  >
                    设为今天
                  </button>
                  
                  <button
                    onClick={onUpdate}
                    className="bg-black text-white px-6 py-3 font-bold hover:bg-gray-800 transition-colors"
                  >
                    保存
                  </button>
                  
                  <button
                    onClick={() => setEditingConfig(false)}
                    className="px-6 py-3 border-2 border-black font-bold hover:bg-gray-100 transition-colors"
                  >
                    取消
                  </button>
                </div>
              </div>
            </div>
          )}
          
          {/* Help Text */}
          <div className="bg-yellow-50 p-6 border-2 border-yellow-600">
            <h4 className="font-bold mb-2 flex items-center">
              <span className="text-2xl mr-2">ℹ️</span>
              说明
            </h4>
            <ul className="space-y-2 text-sm">
              <li>• 当您添加或删除地点时，更新日期会<strong>自动更新</strong>为当天</li>
              <li>• 您也可以在此处<strong>手动修改</strong>更新日期</li>
              <li>• 此日期会显示在网站页脚的"Latest Update"区域</li>
              <li>• 推荐格式：YYYY.M.D（例如：2025.8.1）</li>
            </ul>
          </div>
        </div>
      </div>
    </div>
  )
}
